import React from 'react';
import { Helmet } from 'react-helmet';
import CavityWallInsulationPage from '@/components/cavity-wall-insulation/CavityWallInsulation';
import Layout from '@/components/Layout';

const CavityWallInsulation = () => {
  return (
    <>
      <Helmet>
        <title>EPC Builder</title>
        <meta name="description" content="Cavity Wall Insulation" />
      </Helmet>
      <Layout title="EPC Builder Cavity Wall Insulation">
        <CavityWallInsulationPage />
      </Layout>
    </>
  );
};

export default CavityWallInsulation;
